module.exports = __webpack_public_path__ + "jab/media/data-recycle-selected.9294d759.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/data-recycle-selected.svg
// module id = 197
// module chunks = 0